var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing-page"}},[_c('HeadToolBar'),_c('CustomerFormContent'),_c('AddEditCreditors'),_c('AddEditRecipients'),_c('CreditorsUploadFileDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }